import React from 'react';
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// NEEDS STYLING!!!


const Error404 = () => {

    const { lang } = useParams();
    const { t, i18n } = useTranslation();

    // Change the language dynamically
    React.useEffect(() => {
      i18n.changeLanguage(lang);
    }, [lang, i18n]);

  return (
    <div>
      <div>
            <h1>{t('error404.h1')}</h1>
            <p>{t('error404.text')}</p>
            <a href={`/${lang}`}>{t('error404.link')}</a> {/* linking back to welcome for better UX */}
      </div>
    </div>
  );
};

export default Error404;